module.exports = __webpack_public_path__ + "img/baner_md.78c88256.gif";